/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface RealtimeMessage
 */
export interface RealtimeMessage {
  /**
   *
   * @type {string}
   * @memberof RealtimeMessage
   */
  message?: RealtimeMessageMessageEnum;
}

export const RealtimeMessageMessageEnum = {
  StartRecognition: 'StartRecognition',
  AddAudio: 'AddAudio',
  EndOfStream: 'EndOfStream',
  SetRecognitionConfig: 'SetRecognitionConfig',
  RecognitionStarted: 'RecognitionStarted',
  AudioAdded: 'AudioAdded',
  AddPartialTranscript: 'AddPartialTranscript',
  AddTranscript: 'AddTranscript',
  AddPartialTranslation: 'AddPartialTranslation',
  AddTranslation: 'AddTranslation',
  EndOfTranscript: 'EndOfTranscript',
  AudioEventStarted: 'AudioEventStarted',
  AudioEventEnded: 'AudioEventEnded',
  Info: 'Info',
  Warning: 'Warning',
  Error: 'Error',
} as const;

export type RealtimeMessageMessageEnum =
  (typeof RealtimeMessageMessageEnum)[keyof typeof RealtimeMessageMessageEnum];
